import ENDPOINTS from 'constants/endpoints';
import useConfig from '../../hooks/useConfig';
import useFetchedData from '../../hooks/useFetchedData';

function useParents(currentAddress) {
  const defaultParent = useConfig('general.defaultParent');

  const { data: parentIds = [defaultParent] } = useFetchedData(currentAddress && {
    url: ENDPOINTS.GET_ALL_PARENTS_BY_LOCATION,
    query: { lat: currentAddress.lat, lng: currentAddress.lng },
  }, ({ data: parents = [] } = {}) => parents.map((p) => p.id));

  return parentIds;
}

export default useParents;
